export const marshFulfillmentConfiguration = {
    enabled: false,
    logoUri: 'https://privacy.evidentid.com/cust-icons/wordmark-marsh.png',
    primaryColor: '#002C77',
    secondaryColor: '#fff',
    text: '<p>Get insurance and expertise at your fingertips. Marsh is committed to help you with your insurance needs. Connect with Marsh today to secure compliant insurance, or if you need help with the verification process.</p>',
    buttonLabel: 'GET QUOTE',
    fulfillmentUrl: '',
};
export const evidentFulfillmentConfiguration = {
    enabled: false,
    logoUri: 'https://privacy.evidentid.com/cust-icons/one_click_icon.png',
    buttonLabel: 'Get a Quote',
    fulfillmentUrl: 'https://track.nextinsurance.com/links?serial=99159&channel=Affiliation&source=Partners&affiliate_id=5500',
    primaryColor: '#2BB587',
    secondaryColor: '#2BB597',
    text: 'Need insurance to meet requirements? Instantly receive a quote from our partners.',
};
